import tccf7StateManager from './tccf7StateManager.js';
import tccf7ButtonController from './tccf7ButtonController.js';
import tccf7ConfirmCreate from './tccf7ConfirmCreate.js';
import { TCCF7_CONFIG } from './tccf7Constants.js';

/*-------------------------------------------------------------------------------

  確認画面

--------------------------------------------------------------------------------*/

export default class tccf7Confirm {
  constructor( formId , form , complete ) {
    this.formId = formId;
    this.form   = form;
    this.start  = false;
    if( !this.form ) return;

    const configKey = `${TCCF7_CONFIG.KEY.CONFIRM}_${this.formId}`;
    this.condirm = window[configKey] || false;
    if( !this.condirm ) return;

    const optionKey = `${TCCF7_CONFIG.KEY.OPTION}_${this.formId}`;
    this.options = window[optionKey] || {};
    this.scroll    = this.options.scroll ?? false;
    this.animation = this.options.animation ?? false;
    
    this.confirmId  = this.condirm[TCCF7_CONFIG.TARGET.CONFIRM] ?? false;
    this.inputId    = this.condirm[TCCF7_CONFIG.TARGET.INPUT] ?? false;
    this.completeId = this.condirm[TCCF7_CONFIG.TARGET.COMPLETE] || 'form-complete';
    if( !this.confirmId && !this.inputId ) return;

    this.hasComplete = complete;

    this.tccf7ConfirmCreate    = new tccf7ConfirmCreate();
    this.stateManager          = tccf7StateManager.getInstance(this.formId, this.form);
    this.tccf7ButtonController = tccf7ButtonController.getInstance(this.formId, this.form);

    this.init();
  }

  /*----------------------------------------
    初期設定
  ------------------------------------------*/
  init() {
    this.start = true;
    this.refs(this.form);

    document.addEventListener('tccf7:statusUpdate', (e) => {
      if (e.detail.formId === this.formId) {
        if( e.detail.state != 'complete' && !this.hasComplete) {
          this.completeViewHidden();
        }
        if(e.detail.state === 'confirm') {
          this.confirmView();
          this.inputViewHidden();
        }else if(e.detail.state === 'input') {
          this.inputView();
          this.confirmViewHidden();
        }else if(e.detail.state === 'complete' && !this.hasComplete) {
          this.completeView();
          this.confirmViewHidden();
          this.inputViewHidden();
        }
        this.currentState = e.detail.state
        this.addScroll();
        this.addAnimation();
      }
    });
  }

  /*----------------------------------------
    要素の参照を更新（Observerから呼ばれる）
  ------------------------------------------*/
  refs() {
    this.wraps = {
      confirm  : document.getElementById(this.confirmId),
      input    : document.getElementById(this.inputId),
      complete : document.getElementById(this.completeId)
    };
  }

  /*----------------------------------------
    confirm
  ------------------------------------------*/
  confirmView() {
    if( !this.confirmId || !this.wraps.input ) return;
    if( !this.wraps.confirm ){
      this.wraps.confirm = this.tccf7ConfirmCreate.createConfirm(this.confirmId, this.wraps.input, this.form);
    }
    const inputContents = this.tccf7ConfirmCreate.copyInput(this.wraps.input);
    this.tccf7ConfirmCreate.createConfirmTable(inputContents,this.wraps.confirm);
  }

  confirmViewHidden() {
    if( !this.wraps.confirm ) return;
    this.wraps.confirm.replaceChildren();
  }

  /*----------------------------------------
    input
  ------------------------------------------*/
  inputView() {
    if( !this.wraps.input ) return;
    this.wraps.input.classList.remove(TCCF7_CONFIG.CLASSNAME.NONE);
  }

  inputViewHidden() {
    if( !this.wraps.input ) return;
    this.wraps.input.classList.add(TCCF7_CONFIG.CLASSNAME.NONE);
  }

  /*----------------------------------------
    conplete
  ------------------------------------------*/
  completeView() {
    if( !this.wraps.confirm ) return;
    const success = !this.stateManager.isSpam && this.stateManager.isVerified && !this.stateManager.isValidate;
    this.wraps.complete = this.tccf7ConfirmCreate.createComplete(this.completeId, this.wraps.confirm, success);
  }

  completeViewHidden() {
    if( !this.wraps.complete ) return;
    this.wraps.complete.remove();
  }

  /*----------------------------------------
    オプション：スクロール
  ------------------------------------------*/
  addScroll() {
    if ( !this.scroll ) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const header       = document.querySelector(TCCF7_CONFIG.SELECTORS.HEADER);
        const headerHeight = header ? header.getBoundingClientRect().bottom : 0;
        const targetTop    = this.form.getBoundingClientRect().top - headerHeight + window.scrollY;
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
          window.lenis.scrollTo(targetTop, { immediate: false });
        } else {
          window.scrollTo({ top: targetTop, behavior: 'smooth' });
        }
      });
    });
  }

  /*----------------------------------------
    オプション：カスタムアニメーション
  ------------------------------------------*/
  addAnimation() {
    if( !this.animation ) return;
    const event = new CustomEvent('tccf7:scrollTo', { 
      detail: { 
        state: this.currentState,
        id: this.formId,
      } 
    });
    document.dispatchEvent(event);
  }
}